import styled from 'styled-components';

const Root = styled.div`
  cursor: pointer;
  flex-shrink: 0;
  width: 2.75rem;
  height: 2.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
  background-color: var(--board);
  .material-symbols-rounded {
    font-size: 1.75rem;
    color: var(--text-tertiary);
  }
  &:hover {
    outline: 0.25rem solid var(--tonal-deep);
    .material-symbols-rounded {
      color: var(--text-primary);
    }
    &:active {
      background-color: var(--tonal-blue);
      outline: 0.25rem solid var(--primary);
      .arrow {
        color: var(--primary);
      }
    }
  }
`;

interface Props {
  fold: boolean;
}

const ArrowBoxInModal = ({ fold }: Props) => {
  const icon = fold ? 'keyboard_arrow_down' : 'keyboard_arrow_up';

  return (
    <Root>
      <span className='material-symbols-rounded'>{icon}</span>
    </Root>
  );
};

export default ArrowBoxInModal;
